// extracted by mini-css-extract-plugin
export var leftAlign = "_22-2";
export var popper = "_22-0";
export var subtitle = "_22-1";